import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import api from '../api/axios';

export default function VerifyRegistrationPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get(`/auth/verify-registration/${token}`)
      .then(() => setStatus('success'))
      .catch(err => {
        setMessage(err.response?.data?.message || 'Lien invalide ou expiré.');
        setStatus('error');
      });
  }, [token]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-500 font-bold text-sm">Vérification en cours…</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-md w-full bg-white rounded-[2.5rem] shadow-2xl shadow-blue-900/5 p-10 border border-slate-100 text-center"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-50 rounded-3xl mb-6">
            <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-black text-slate-900 mb-3">Email confirmé !</h1>
          <p className="text-slate-500 font-medium text-sm leading-relaxed mb-6">
            Votre demande d'inscription a bien été reçue et est en cours d'examen.
          </p>
          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4 mb-8">
            <p className="text-blue-700 font-bold text-sm">Vous serez contacté(e) dans moins de 24 heures.</p>
          </div>
          <Link to="/login" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-black py-3 px-8 rounded-2xl transition-colors text-sm">
            Retour à la connexion
          </Link>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full bg-white rounded-[2.5rem] shadow-2xl shadow-blue-900/5 p-10 border border-slate-100 text-center"
      >
        <div className="inline-flex items-center justify-center w-20 h-20 bg-red-50 rounded-3xl mb-6">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>
        <h1 className="text-2xl font-black text-slate-900 mb-3">Lien invalide</h1>
        <p className="text-slate-500 font-medium text-sm leading-relaxed mb-8">{message}</p>
        <Link to="/inscription" className="inline-block bg-slate-600 hover:bg-slate-700 text-white font-black py-3 px-8 rounded-2xl transition-colors text-sm">
          Recommencer l'inscription
        </Link>
      </motion.div>
    </div>
  );
}
